"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColorPicker = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2020 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var isEqual_1 = tslib_1.__importDefault(require("lodash/isEqual"));
var react_intl_1 = require("react-intl");
var Button_1 = require("../Button");
var ColorPickerMatrix_1 = require("./components/ColorPickerMatrix");
var HexColorInput_1 = require("./components/HexColorInput");
var HueColorPicker_1 = require("./components/HueColorPicker");
var ColorsPreview_1 = require("./components/ColorsPreview");
var utils_1 = require("./utils");
var WrappedColorPicker = /** @class */ (function (_super) {
    tslib_1.__extends(WrappedColorPicker, _super);
    function WrappedColorPicker(props) {
        var _this = _super.call(this, props) || this;
        var currentHslColor = utils_1.getHslFromRgbColor(_this.props.initialRgbColor);
        _this.state = {
            draftHslColor: currentHslColor,
        };
        _this.onColorSelected = _this.onColorSelected.bind(_this);
        _this.onHexInputColorSelected = _this.onHexInputColorSelected.bind(_this);
        return _this;
    }
    WrappedColorPicker.prototype.onColorSelected = function (selectedColor) {
        this.setState({
            draftHslColor: selectedColor,
        });
    };
    WrappedColorPicker.prototype.onHexInputColorSelected = function (selectedColor) {
        if (utils_1.isHslColorBlackOrWhite(selectedColor)) {
            this.setState({
                draftHslColor: tslib_1.__assign(tslib_1.__assign({}, selectedColor), { h: this.state.draftHslColor.h }),
            });
        }
        else {
            this.onColorSelected(selectedColor);
        }
    };
    WrappedColorPicker.prototype.render = function () {
        var _this = this;
        var currentHslColor = utils_1.getHslFromRgbColor(this.props.initialRgbColor);
        var t = this.props.intl.formatMessage;
        return (react_1.default.createElement("div", { className: "color-picker-container" },
            react_1.default.createElement(ColorPickerMatrix_1.ColorPickerMatrix, { initColor: this.state.draftHslColor, onColorSelected: this.onColorSelected }),
            react_1.default.createElement("div", { className: "color-picker-control-wrapper" },
                react_1.default.createElement(HueColorPicker_1.HueColorPicker, { initColor: this.state.draftHslColor, onChange: this.onColorSelected }),
                react_1.default.createElement(HexColorInput_1.HexColorInput, { initColor: this.state.draftHslColor, onInputChanged: this.onHexInputColorSelected, placeholder: t({ id: "gs.color-picker.inputPlaceholder" }), label: t({ id: "gs.color-picker.hex" }) }),
                react_1.default.createElement(ColorsPreview_1.ColorsPreview, { currentHslColor: currentHslColor, draftHslColor: this.state.draftHslColor, currentTextLabel: t({ id: "gs.color-picker.currentColor" }), draftTextLabel: t({ id: "gs.color-picker.newColor" }) }),
                react_1.default.createElement("div", { className: "color-picker-buttons-wrapper" },
                    react_1.default.createElement(Button_1.Button, { value: t({ id: "gs.color-picker.cancelButton" }), className: "gd-button-secondary gd-button color-picker-button", onClick: this.props.onCancel }),
                    react_1.default.createElement(Button_1.Button, { value: t({ id: "gs.color-picker.okButton" }), disabled: isEqual_1.default(this.props.initialRgbColor, utils_1.getRgbFromHslColor(this.state.draftHslColor)), className: "gd-button-action gd-button color-picker-ok-button", onClick: function () { return _this.props.onSubmit(utils_1.getRgbFromHslColor(_this.state.draftHslColor)); } })))));
    };
    return WrappedColorPicker;
}(react_1.Component));
/**
 * @internal
 */
exports.ColorPicker = react_intl_1.injectIntl(WrappedColorPicker);
//# sourceMappingURL=ColorPicker.js.map